<script lang="ts">
  import {onMount} from 'svelte';
  import {appEvents} from '@/services';
  import {project} from '@/store';

  export let isUploading = false;

  let preview: string = '';
  let filename: string = 'New Video';
  let currentProgress: number = 0;
  let progress: number = 0;
  let message: string = 'Preparing Video';
  const animationDelay = 500;
  onMount(async () => {
    appEvents.on('action-started', data => {
      preview = data.preview;
      filename = data.filename;
      message = data.step;

      isUploading = true;
    });

    appEvents.on('upload-progress', data => {
      currentProgress = Math.round(data.currentData);
      if (currentProgress > progress) {
        progress = Math.round(data.currentData);
      }
      isUploading = true;
    });

    appEvents.on('video-encoding-started', result => {
      message = 'Optimizing Video';
      progress = 0;
      isUploading = true;
    });

    appEvents.on('video-encoding-progress', result => {
      currentProgress = result.data.progress;
      if (currentProgress > progress) {
        progress = result.data.progress;
      }
      isUploading = true;
    });

    project.subscribe(project => {
      message = 'Uploading Video';
      progress = project.uploadProgress;
    });
  });
</script>

{#if isUploading}
  <div class="w-full lg:w-[calc(25%-1.5rem)]">
    <div
      class="relative h-auto w-full overflow-hidden rounded-xl border-2 border-transparent bg-zinc-100 transition-all hover:border-primary dark:bg-zinc-700"
    >
      {#if preview != ''}
        <img class="aspect-video w-full object-cover" src={preview} alt="video-thumbnail" />
      {:else}
        <img
          class="aspect-video w-full object-cover"
          src="https://storage.googleapis.com/sermonshots-local-storage/images/1.png"
          alt="video-thumbnail"
        />
      {/if}

      <div
        id="spinner-container"
        class="absolute left-0 top-0 flex h-full w-full flex-col items-center justify-end bg-white/30 p-2"
      >
        <div class="relative h-4 w-full rounded-full">
          <div class="absolute h-3 w-full animate-pulse rounded-full bg-white bg-opacity-30" />
          <div
            class="absolute z-20 h-3 rounded-full bg-gradient-to-r from-primary to-secondary transition-all duration-500 ease-in-out"
            style="width: {progress}%"
          />
        </div>
      </div>
    </div>
    <div class="text-start">
      <h1 class="truncate pt-1 text-sm font-semibold text-gray-500 dark:text-zinc-200">{filename}</h1>
      <h2 id="queued-video-date" class="truncate pt-1 text-xs text-gray-500 lg:text-sm">{message}</h2>
    </div>
    <div class="mt-2 flex w-full justify-start gap-2">
      <div
        class="mt-1 animate-pulse rounded-md bg-zinc-300 text-sm"
        style="width: {(Math.random() * 80 + 20).toFixed(0)}%; animation-delay: {animationDelay}ms;"
      >
        &nbsp;
      </div>
      <div
        class="mt-1 animate-pulse rounded-md bg-zinc-300 text-xs lg:text-sm"
        style="width: {(Math.random() * 90 + 10).toFixed(0)}%; animation-delay: {animationDelay}ms;"
      >
        &nbsp;
      </div>
    </div>
  </div>
{/if}
